module.exports = __webpack_public_path__ + "img/Spinner-1s-200px.baaf66dd.baaf66dd.gif";